import { useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import { STATIC_URL } from '../../api/urls'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { IconButton, Typography } from '@mui/material'

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`

interface Props {
  address: string
}

export default function PdfViewer({ address }: Props) {
  const [numPages, setNumPages] = useState(0)
  const [pageNumber, setPageNumber] = useState(1)
  const [error, setError] = useState(false)
  return (
    <div>
      <Document
        className="w-fit mx-auto"
        file={STATIC_URL + address}
        error={<div className="p-3 text-zinc-600">خطا در لود فایل</div>}
        loading={<div className="p-3 text-zinc-600">در حال لود فایل</div>}
        onLoadError={() => setError(true)}
        onSourceError={() => setError(true)}
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
      >
        <Page
          className="w-fit p-1 border-2 rounded-md h-50"
          height={450}
          pageNumber={pageNumber}
        />
      </Document>
      {!error && (
        <div className="w-fit flex flex-row mx-auto opacity-80">
          <IconButton
            disabled={pageNumber <= 1}
            onClick={() => setPageNumber((page) => page - 1)}
          >
            <ArrowForwardIosIcon
              sx={{ color: pageNumber <= 1 ? 'primary' : 'disabled' }}
            />
          </IconButton>
          <Typography fontSize="medium" alignSelf="center" width={40} textAlign="center">
            {`${pageNumber.toLocaleString('fa-IR')} از ${numPages.toLocaleString(
              'fa-IR'
            )}`}
          </Typography>
          <IconButton
            disabled={pageNumber >= numPages}
            onClick={() => setPageNumber((page) => page + 1)}
          >
            <ArrowBackIosNewIcon
              sx={{ color: pageNumber >= numPages ? 'primary' : 'disabled' }}
            />
          </IconButton>
        </div>
      )}
    </div>
  )
}
